import { Box, Container } from "@sembark-travel/ui-base"
import { Breadcrumbs } from "@sembark-travel/ui-router"
import { Helmet } from "react-helmet-async"
import { generatePath, useNavigate } from "../../../../router-utils"
import { MergeAccounts } from "../../../../Accounting/MergeAccount"

export default function MergeAccountsPage() {
	const navigate = useNavigate()
	const listPage = generatePath("/accounting/accounts")
	function navigateToList() {
		return navigate("/accounting/accounts")
	}
	return (
		<>
			<Helmet>
				<title>Merge Accounts</title>
			</Helmet>
			<Breadcrumbs
				title="Merge Accounts"
				items={[
					[listPage, "Accounts"],
					["", "Merge"],
				]}
			/>
			<Box paddingX={{ md: "4" }} paddingY={{ md: "8" }}>
				<Box maxWidth="6xl" marginX="auto">
					<Box borderWidth={{ md: "1" }} rounded="md" bgColor="default">
						<Container paddingY="6">
							<MergeAccounts
								onSuccess={navigateToList}
								onCancel={navigateToList}
							/>
						</Container>
					</Box>
				</Box>
			</Box>
		</>
	)
}
